import { checkCoupon } from "services/coupon";

interface IGetPlansWithDiscountProps {
  coupon?: string;
  currentPlans: any;
  originalValueOneTime?: number;
  originalValueMonth?: number
}

export const getPlansWithDiscounts = async ({
  coupon,
  currentPlans,
  originalValueOneTime,
  originalValueMonth
}: IGetPlansWithDiscountProps) => {
  try {
    if (!coupon) return currentPlans;

    const { data: dataCoupon } = await checkCoupon(coupon || "");

    if (!dataCoupon || dataCoupon.max_redemptions === dataCoupon.times_redeemed) {
      return currentPlans;
    }

    const products = dataCoupon.metadata?.products?.split(",") || [];

    const plans = currentPlans.map((plan: any) => {
      if (originalValueMonth && originalValueOneTime) {
        plan.unit_amount = plan.type === "one_time" ? originalValueOneTime : originalValueMonth
      }

      if (dataCoupon.percent_off && products.includes(plan.id)) {

        const discountPercentage = parseFloat(dataCoupon.percent_off);
        const discount = discountPercentage / 100;
        const discountedValue = plan.unit_amount * (1 - discount);
        const finalDiscountedValue = parseFloat(discountedValue.toFixed(2))
        plan.unit_amount = finalDiscountedValue <= 0 ? 5 : finalDiscountedValue;

        return plan;
      }

      if (dataCoupon.amount_off && products.includes(plan.id)) {
        const discountAmount = parseFloat(dataCoupon.amount_off);

        const value = plan.unit_amount - discountAmount;
        plan.unit_amount = value <= 0 ? 5 : value;

        return plan;
      }



      return plan;
    });

    return plans;
  } catch (err) {
    console.log(err);
    return currentPlans;
  }
};